import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { getJSON } from '../util';

export function* getContentData(args) {
    const api = yield select(state => state.api);
    const default_args = {
        ...api.params,
        content_type: 'content',
        property: 'cygnus',
        limit: 2,
    };

    return yield call(getJSON, `${api.host}/content/content`, {...default_args, ...args});
}

export function* fetchNav({ payload: tag }) {
    const data = yield call(getContentData, { tag: encodeURIComponent(tag) });
    const nav = yield select(state => state.content && state.content.nav);

    yield put({
        type: 'content:update',
        payload: {
            nav: {
                ...nav,
                [tag]: data,
            },
        },
    });
}

export function* fetchPromoted({ payload: limit}) {
    const stories = yield call(getJSON, '/api/content/promoted', { limit: limit });

    yield put({
        type: 'content:update',
        payload: {
            promoted: stories,
        },
    });
}

export function* fetchHexagram({ payload: limit }) {
    const data = yield call(getContentData, {
        content_type: null,
        property: 'cygnus',
        tag: 'hexagram',
        limit: limit,
    });

    yield put ({
        type: 'content:update',
        payload: {
            hexagram: data,
        },
    });
}

export function* root() {
    yield all([
        takeEvery('content:fetchNav', fetchNav),
        takeEvery('content:fetchPromoted', fetchPromoted),
        takeEvery('content:fetchHexagram', fetchHexagram),
    ]);
}
